module.exports = __webpack_public_path__ + "img/doctor1.78794bf8.jpg";